import { FC } from 'react'
import withReadyEvent from 'hocs/withReadyEvent/withReadyEvent'

const NAReadyEventHandlerComponent: FC = () => {
  return null
}

export const NAReadyEventHandler = withReadyEvent(NAReadyEventHandlerComponent)
